<aside class="qr-code-wrapper" *ngIf="!additionalBanners && !loadingBanners">
  <p class="qr-code-text">Відскануй, щоб завантажити додаток</p>
  <img *ngIf="lang === 'ua'" class="qr-code-image" src="../../../../../assets/to_app_ua.webp">
  <img *ngIf="lang === 'ru'" class="qr-code-image" src="../../../../../assets/to_app_ru.webp">
  <a rel="nofollow" href="https://play.google.com/store/apps/details?id=ua.com.llc.zdorovi" target="_blank"
    class="platform">
    <img class="platform-icon" src="../../../assets/icons/play-market-icon.svg" alt="google-play-icon"
      title="Google Play">
    <p class="platform-text">Google Play</p>
  </a>
  <a rel="nofollow" href="https://apps.apple.com/ua/app/zdorovi-ua-пошук-ліків/id1591178876?platform=iphone"
    target="_blank" class="platform">
    <img class="platform-icon" src="../../../assets/icons/app-store-icon.svg" alt="app-store-icon" title="App Store">
    <p class="platform-text">App Store</p>
  </a>
</aside>

<aside class="qr-code-wrapper--banner" *ngIf="additionalBanners?.length > 0">
  <a [href]="additionalBanners[0].redirectTo">
    <picture class="additional-banner-picture">
      <source [srcset]="bannerImages + additionalBanners[0].img + '.webp'" type="image/webp">
      <img bz-image [src]="bannerImages + 'png/' + additionalBanners[0].img + '.png'" [title]="'Банер'" [alt]="'Банер'">
    </picture>
  </a>
  <p class="qr-code-text">Відскануй, щоб завантажити додаток</p>
  <img *ngIf="lang === 'ua'" class="qr-code-image" src="../../../../../assets/to_app_ua.webp">
  <img *ngIf="lang === 'ru'" class="qr-code-image" src="../../../../../assets/to_app_ru.webp">
  <a rel="nofollow" href="https://play.google.com/store/apps/details?id=ua.com.llc.zdorovi" target="_blank"
    class="platform">
    <img class="platform-icon" src="../../../assets/icons/play-market-icon.svg" alt="google-play-icon"
      title="Google Play">
    <p class="platform-text">Google Play</p>
  </a>
  <a rel="nofollow" href="https://apps.apple.com/ua/app/zdorovi-ua-пошук-ліків/id1591178876?platform=iphone"
    target="_blank" class="platform">
    <img class="platform-icon" src="../../../assets/icons/app-store-icon.svg" alt="app-store-icon" title="App Store">
    <p class="platform-text">App Store</p>
  </a>
</aside>

<div class="top-nav-bar">
  <bz-button class="catalog" (click)="toCatalog()" [type]="colorsApp.ce1" [k]="1" [text]="'catalog' | transloco"
    [textColor]="colorsApp.text" [icon]="'bookmark.svg'" [content]="'all'" [size]="{w: 70, h: 70}"
    [radius]="['50%','50%','50%','50%']"></bz-button>
  <bz-button class="my-reserves" (click)="openPrivatePageBlock(listComponent.private, 'orders')" [type]="colorsApp.ce1"
    [k]="1" [text]="'myReservs' | transloco" [textColor]="colorsApp.text" [icon]="'shopping-cart.svg'" [content]="'all'"
    [size]="{w: 70, h: 70}" [radius]="['50%','50%','50%','50%']">
  </bz-button>
  <bz-button class="history-orders" (click)="openPrivatePageBlock(listComponent.private, 'history')"
    [type]="colorsApp.ce1" [k]="1" [text]="'history' | transloco" [textColor]="colorsApp.text" [icon]="'home.svg'"
    [content]="'all'" [size]="{w: 70, h: 70}" [radius]="['50%','50%','50%','50%']"></bz-button>
  <bz-button (click)="openPrivatePageBlock(listComponent.private, 'favorite')" [type]="colorsApp.ce1" [k]="1"
    [text]="'favorite' | transloco" [textColor]="colorsApp.text" [icon]="'heart.svg'" [content]="'all'"
    [size]="{w: 70, h: 70}" [radius]="['50%','50%','50%','50%']">
  </bz-button>
  <bz-button [ngStyle]="{'margin-right': '0px'}" (click)="openPrivatePageBlock(listComponent.private, 'viewed')"
    [type]="colorsApp.ce1" [k]="1" [text]="'recent' | transloco" [textColor]="colorsApp.text" [icon]="'viewed.svg'"
    [content]="'all'" [size]="{w: 70, h: 70}" [radius]="['50%','50%','50%','50%']"></bz-button>
</div>

<div class="banners" *ngIf="mainBanners?.length > 0">
  <img class="nav-left" *ngIf="shownBannerIndex > 0" (click)="prevSlide()"
    src="../../../../../assets/icons/nav-arrow.svg">
  <ng-container *ngFor="let banner of mainBanners; let i = index">
    <a [href]="banner.redirectTo" *ngIf="shownBannerIndex === i">
      <picture class="main-banner-picture">
        <source [srcset]="bannerImages + banner.img + '.webp'" type="image/webp">
        <img bz-image [src]="bannerImages + 'png/' + banner.img + '.png'" [title]="'Банер'" [alt]="'Банер'">
      </picture>
    </a>
  </ng-container>
  <img class="nav-right" *ngIf="shownBannerIndex < mainBanners.length - 1" (click)="nextSlide()"
    src="../../../../../assets/icons/nav-arrow.svg">
</div>

<div class="tips-day" [class.tips-day-with-banner]="mainBanners?.length > 0">
  <p (click)="openAllTipsPage()" class="tips-title">
    {{ 'tipOfTheDay' | transloco }}
    <span class="tips-count">{{ (adviceDayList | async)?.length }}</span>
    <span (click)="openAllTipsPage()" class="show_more">{{ 'show_more' | transloco }}</span>
  </p>
  <div class="tips-card-wrapper">
    <ng-container *ngIf="(adviceDayList | async)?.length > 0">
      <a class="tip-link" *ngFor="let tip of (adviceDayList | async)"
        [routerLink]="getAdviceLink() + '/' + tip?.nameEn">
        <div class="tip-card">
          <picture class="tip-image">
            <source [srcset]="images + tip.photo + '.webp'" type="image/webp">
            <img bz-image [src]="images + 'png/' + tip.photo + '.png'" [title]="tip.title"
              [alt]="'Картинка для ' + tip.title">
          </picture>
          <div class="description-wrapper">
            <p class="tip-description">{{tip.title}}</p>
          </div>
        </div>
      </a>
    </ng-container>

    <!-- <ng-template #skeletonTemp>
      <div *ngFor="let tip of [1, 2, 3, 4, 5]" class="tip-card">
        <span class="tip-image">
          <ngx-skeleton-loader [theme]="{ height: '187px',width: '187px'}"></ngx-skeleton-loader>
        </span>
        <div class="description-wrapper">
          <p class="tip-description">
            <ngx-skeleton-loader [theme]="{ height: '14px',width: '100px'}"></ngx-skeleton-loader>
          </p>
        </div>
      </div>
    </ng-template> -->

    <ng-container>
      <div *ngIf="(adviceDayList | async)?.length >= 5" (click)="openAllTipsPage()" class="btn-show-all-tips">
        <div class="btn-inner">
          <img src="../../../../../assets/catalog-icons/more.svg" [title]="'show_more' | transloco" alt="More">
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div class="most-often-booked">
  <p (click)="openAllTopReserves()" class="tips-title">
    {{ 'mostOftenBooked' | transloco }}
    <span class="tips-count">{{ (topBookingProductsList | async).length }}</span>
    <span (click)="openAllTopReserves()" class="show_more">{{ 'show_more' | transloco }}</span>
  </p>

  <div class="often-products-wrapper">
    <ng-container *ngIf="(topBookingProductsList | async).length > 0">
      <ng-container *ngFor="let product of (topBookingProductsList | async); trackBy: trackById;">
        <div class="often-product">
          <a class="product-key" [routerLink]="getMostOftenLink()" [queryParams]="{t: product?.key}">
            <p class="inner-key">{{ product.key | transloco }}</p>
          </a>
          <div class="product">
            <bz-product [isHomePage]="true" [BzProduct]="product" [isBtnToMenu]="false"></bz-product>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- <ng-template #isSkeletonOften>
      <ng-container *ngFor="let item of [1,2,3,4,5,6,7,8,9,0]">
        <div class="often-product">
          <div class="product-key">
            <ngx-skeleton-loader [theme]="{ height: '14px',width: '100px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          </div>
          <div class="product">
            <bz-product [isHomePage]="true" [isSkeleton]="true" [isBtnToMenu]="false"></bz-product>
          </div>
        </div>
      </ng-container>
    </ng-template> -->

    <ng-container>
      <div *ngIf="(topBookingProductsList | async)?.length >= 10" (click)="openAllTopReserves()"
        class="btn-show-all-tips">
        <div class="btn-inner">
          <img src="../../../../../assets/catalog-icons/more.svg" [title]="'show_more' | transloco" alt="More">
        </div>
      </div>
    </ng-container>
  </div>

</div>

<div class="instruction" id="instruction-faq">
  <p class="instruction-title">
    {{'howToReserve' | transloco}}
  </p>
  <div class="steps-wrapper">
    <div class="step">
      <img class="step-image" src="../../../../../assets/illustration_1.svg" alt="search-icon"
        [title]="'search' | transloco">
      <div class="step-text-wrapper">
        <p class="step-heading">{{'search' | transloco}}</p>
        <p class="step-description">{{'step1' | transloco}}</p>
      </div>
    </div>
    <div class="step">
      <img class="step-image" src="../../../../../assets/illustration_2.svg" alt="search-icon"
        [title]="'choseGoods' | transloco">
      <div class="step-text-wrapper">
        <p class="step-heading">{{'choseGoods' | transloco}}</p>
        <p class="step-description">{{'step2' | transloco}} <span class="transform-letter">"{{'in-pharmcy' |
            transloco}}"</span>.</p>
      </div>
    </div>
    <div class="step">
      <img class="step-image" src="../../../../../assets/illustration_7.svg" alt="search-icon"
        [title]="'choosePharma' | transloco">
      <div class="step-text-wrapper">
        <p class="step-heading">{{'choosePharma' | transloco}}</p>
        <p class="step-description" style="padding-right: 5px;">{{'step3' | transloco}} "{{'toOrder' | transloco}}".</p>
      </div>
    </div>
    <div class="step">
      <img class="step-image" src="../../../../../assets/illustration_4.svg" alt="search-icon"
        [title]="'reserving' | transloco">
      <div class="step-text-wrapper">
        <p class="step-heading">{{'reserving' | transloco}}</p>
        <p class="step-description">{{'step4' | transloco}} "{{'reserve' | transloco}}".</p>
      </div>
    </div>
  </div>
</div>